import { render, staticRenderFns } from "./live-behavior-analysis.vue?vue&type=template&id=29600722&scoped=true"
import script from "./live-behavior-analysis.vue?vue&type=script&lang=js"
export * from "./live-behavior-analysis.vue?vue&type=script&lang=js"
import style0 from "./live-behavior-analysis.vue?vue&type=style&index=0&id=29600722&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29600722",
  null
  
)

export default component.exports